import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { toToolkitApplicationState } from "@store/Framework/Store/ApplicationState";

export const getSettingsCollection = (state: ApplicationState) => {
    return toToolkitApplicationState(state).context.settings.settingsCollection;
};

export const getWebsite = (state: ApplicationState) => state.context.website;

export const getCurrentLanguage = (state: ApplicationState) => state.context.session.language;
